import React, { Component } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { timeConvert } from "../Branches/ContactPageTools";
import moment from "moment";

class MingledDialog extends Component {
  render() {
    const language = this.props.language;
    const settings = this.props.settings
    return (
      <Dialog
        open={this.props.dialogOpen}
        onClose={(e) => {
          this.props.onClose(e);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: language == "english" ? "left" : "right" }}
        >
          {language === "english"
            ? "You cannot add this item"
            : "لا يمكنك إضافة هذا المنتج"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ textAlign: language == "english" ? "left" : "right" }}
          >
            {language == "english"
              ? settings.custom_texts.no_mingling
              : settings.custom_texts.no_mingling_ar}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button
            onClick={(e) => {
              this.props.onClose(e);
              e.stopPropagation();
            }}
            color="primary"
          >
            {language == "english" ? "Ok" : "حسنا"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(MingledDialog);
